export const palette = {
  white: '#fff',
  gray100: '#f8f8f8',
  gray200: '#f0f0f0',
  gray300: '#e6e6e6',
  gray400: '#cecece',
  gray500: '#a0a0a0',
  gray600: '#687180',
  gray700: '#545454',
  gray800: '#323232',
  gray900: '#212529',
  black: '#000000',
  blue: '#7A99AC',
  blue300: '#1B365D30',
  blue500: '#1B365D50',
  blue700: '#4F758B',
  indigo: '#6610f2',
  purple: '#6f42c1',
  pink: '#e83e8c',
  red: '#e1261c',
  red300: '#e1261c30',
  red500: '#e1261c50',
  red700: '#e1261c70',
  orange: '#dc992f', // #dull-orange
  yellow: '#ffcc1d', // #golden-yellow
  greenBlue: '#09c58e',
  teal: '#20c997',
  cyan: '#3efac3', // #greenish-cyan
  green: '#3f9c47',
};
